(function () {
  if (window.__collectionSwatchesLoaded) return;
  window.__collectionSwatchesLoaded = true;

  function getMoneyFormat() {
    var section = document.querySelector("[data-money-format]");
    return (section && section.getAttribute("data-money-format")) || "${{amount}}";
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Helpers && typeof window.theme.Helpers.formatMoney == "function") {
      return window.theme.Helpers.formatMoney(cents, getMoneyFormat());
    }
    return "$" + (cents / 100).toFixed(2);
  }

  // Keep the card's badge in step with the colour picked: Sold Out wins, then the sale badge.
  function updateBadge(card, data) {
    var inner = card.querySelector(".product-index-inner");
    if (!inner) return;

    var current = inner.querySelector(":scope > .so.icn, :scope > .sale-item.icn");
    if (current) current.remove();

    var badge = null;
    if (!data.available) {
      badge = document.createElement("div");
      badge.className = "so icn";
      badge.textContent = "Sold Out";
    } else if (data.compare_at_price && data.compare_at_price > data.price) {
      badge = document.createElement("div");
      badge.className = "sale-item sale-item--percentage icn";
      badge.textContent = "Save " + Math.round(((data.compare_at_price - data.price) * 100) / data.compare_at_price) + "%";
    }
    if (badge) inner.insertBefore(badge, inner.firstChild);
  }

  function updateCard(card, data) {
    var imageWrapper = card.querySelector("[data-grouped-card-image]");
    if (imageWrapper) {
      var img = imageWrapper.querySelector("img");
      if (img && data.featured_image) {
        img.src = data.featured_image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "$1?width=600");
        img.removeAttribute("srcset");
      }
    }

    var priceWrapper = card.querySelector("[data-grouped-card-price]");
    if (priceWrapper) {
      var priceEl = priceWrapper.querySelector(".price");
      var onSale = data.compare_at_price && data.compare_at_price > data.price;
      if (priceEl) {
        priceEl.classList.toggle("price--on-sale", !!onSale);
        priceEl.classList.toggle("price--sold-out", !data.available);
      }
      var regular = priceWrapper.querySelector(".price-item--regular");
      var sale = priceWrapper.querySelector(".price__sale .price-item--sale");
      if (onSale) {
        if (sale) sale.textContent = formatMoney(data.price);
        var compareRegular = priceWrapper.querySelector(".price__sale .price-item--regular");
        if (compareRegular) compareRegular.textContent = formatMoney(data.compare_at_price);
      } else if (regular) {
        regular.textContent = formatMoney(data.price);
      }
    }

    updateBadge(card, data);

    card.querySelectorAll("[data-grouped-card-link]").forEach(function (link) {
      link.setAttribute("href", data.url);
    });
  }

  document.addEventListener("click", function (event) {
    var swatch = event.target.closest("[data-collection-swatches] [data-colour-swatch]");
    if (!swatch) return;
    var url = swatch.getAttribute("data-swatch-url");
    if (!url) return;
    var card = swatch.closest(".product-index");
    if (!card) return;

    event.preventDefault();
    var swatchesContainer = swatch.closest("[data-collection-swatches]");
    swatchesContainer.querySelectorAll("[data-colour-swatch]").forEach(function (el) {
      el.classList.toggle("is-active", el === swatch);
      el.setAttribute("aria-current", el === swatch ? "true" : "false");
    });

    // Quick clicks across colours can come back out of order; only the last one picked may update the card.
    card.__swatchRequest = url;
    fetch(url + ".js")
      .then(function (response) {
        if (!response.ok) throw new Error("Product fetch failed");
        return response.json();
      })
      .then(function (data) {
        if (card.__swatchRequest === url) updateCard(card, data);
      })
      .catch(function () {});
  });
})();
